<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('packages')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="content-wrapper">
        <span
          >You currently have no packages selected. Please select one of the
          below to continue using the portal.</span
        >
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label>{{ $t("business_category") }}</label>
          <app-input
            type="search-select"
            :placeholder="$t('select_business_category')"
            :list="categories"
            v-model="inputs.category_id"
            :required="true"
          />
        </div>
      </div>
      <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_package") }}
          </button>
        </div> -->
      <!-- </div> -->
    </div>

    <!-- <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    /> -->
    <div class="row" >
      <div class="col-sm-4" v-for="(item, index) in packages" :key="index" >
        <div class="card mb-3">
          <div class="card-header">
            <div v-if="item.background != null" v-bind:style="{ 'background-image': 'url(' + item.background + ')','background-size': '100% 100%', 'width': '100%', 'height': '100px'}"></div>
            <h2 class="text-center" v-else style="color:#292f4c">{{ item.title }}</h2>
          </div>
          <div class="card-body text-center">
            <h3>{{ item.amount }}</h3>
            <h5 class="text-muted"><small>{{item.time_period +' '+ item.period}}</small></h5>
          </div>
          <!-- <ul class="list-group list-group-flush text-center" v-for="inc in item.include" :key="inc">
            <li class="list-group-item"><i class="fas fa-check mx-2" style="color:#292f4c"></i>{{ inc }}</li>
          </ul> -->
          <span class="text-center m-2" v-html="item.include"></span>
          <div class="card-footer border-top-0 text-center">
            <a href="#" @click="btnSubmit(item.id)" class="text-uppercase" style="color:#292f4c">{{ $t("purchase_now") }} <i class="fas fa-arrow-right"></i></a>
          </div>
        </div>
        <!-- <div class="card card-with-search border-0 card-with-shadow mb-4" style="height:300px">
          <div
            class="
              card-header
              d-flex
              justify-content-between
              align-items-center
              p-primary
              bg-transparent
            "
          >
            <h5 class="card-title d-inline-block mb-0">{{ item.title }}</h5>
          </div>
          <div class="card-body">
            <div class="text-justify" v-for="inc in item.include" :key="inc">
              {{ inc }}
            </div>
          </div>
          <button @click="btnSubmit(item.id)" class="btn btn-success mx-2 my-4">
            {{ $t("purchase_now") +' ('+ item.amount +')' }}
          </button>
        </div> -->
      </div>
    </div>

    <packages-paymentmodal
      v-if="isPaymentModalActive"
      :data="inputs"
      :selected-url="selectedUrl"
      @close-modal="closePaymentModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../core/helpers/app/AppFunction";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper.js";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers, FormMixin],
  data() {
    return {
      inputs: {},
      // categories:[
      //   {íd: "", value:""},
      //   {íd: "Construction", value:"Construction"},
      //   {íd: "Security", value:"Security"},
      // ],
      // categories: [
      //   // { id: "", value: "Choose One" },
      //   { id: "Construction", value: "Construction" },
      //   { id: "Security", value: "Security" },
      // ],
      categories: [],
      packages: {},
      isPaymentModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.PACKAGE_LISTING,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("period"),
            type: "custom-html",
            key: "period",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("select"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    /**
     * for open add edit modal
     */
    
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    getCompanyCategories() {
      axiosGet(actions.CATEGORIES)
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => {
          
        });
    },

    /**
     * for close add edit modal
     */
    closePaymentModal() {
      $("#payment-Modal").modal("hide");
      this.isPaymentModalActive = false;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("select")) {
        location.replace("/admin/stripePay/" + rowData.id);
      }
    },

    detail(id) {
      window.location = "/admin/package/detail/" + id;
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    getPackages() {
      axiosGet(actions.PACKAGE_LISTING)
        .then((res) => {
          this.packages = res.data.data;
        })
        .catch((error) => {
          
        });
    },
    btnSubmit(id) {
      if (this.inputs.category_id == null) {
        this.$toastr.e("Please Select Your Busniess Category");
      } else {
        axiosGet(actions.LAST_INVOICE)
          .then((response) => {
              if (response.data.result == 'paid') {
                  this.$toastr.w(this.$t("package_already_exists"));
              }
              else {
                  let d = this.categories.filter((e, i) => {
                    let a = e.id === this.inputs.category_id;
                    return a;
                  });
                  this.inputs.category_name = d;
                  this.inputs.company_id = this.userCompany;
                  this.inputs.package_id = id;
                  this.isPaymentModalActive = true;
              }
            })
            .catch((error) => {
              
            });
      }
    },
  },
  mounted() {
    this.getPackages();
    this.getCompanyCategories();
  },
  computed: {
    userCompany() {
      return this.$store.state.user.loggedInUser.company_id;
    },
  },
};
</script>
